/**
 * useToast Hook
 * Custom hook for managing toast notifications
 */

import { useState, useCallback } from 'react';

let toastId = 0;

export const useToast = () => {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((message, type = 'info', duration = 3000) => {
        const id = ++toastId;

        setToasts((prev) => [...prev, { id, message, type, duration }]);

        return id;
    }, []);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    const toast = {
        success: (message, duration = 3000) => addToast(message, 'success', duration),
        error: (message, duration = 4000) => addToast(message, 'error', duration),
        info: (message, duration = 3000) => addToast(message, 'info', duration),
        warning: (message, duration = 3500) => addToast(message, 'warning', duration),
    };

    return { toasts, toast, removeToast };
};

export default useToast;
